var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPriorityCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72436 2.2002C8.95456 0.866863 7.03006 0.866861 6.26026 2.20019L0.487608 12.1987C-0.282192 13.532 0.680056 15.1987 2.21966 15.1987H13.765C15.3046 15.1987 16.2668 13.532 15.497 12.1987L9.72436 2.2002ZM8.88116 5.42183C8.88116 4.93095 8.48323 4.53302 7.99235 4.53302C7.50148 4.53302 7.10355 4.93096 7.10355 5.42183V8.97706C7.10355 9.46793 7.50148 9.86586 7.99235 9.86586C8.48323 9.86586 8.88116 9.46793 8.88116 8.97706V5.42183ZM8.88116 11.6435C8.88116 11.1526 8.48323 10.7547 7.99235 10.7547C7.50148 10.7547 7.10355 11.1526 7.10355 11.6435C7.10355 12.1343 7.50148 12.5323 7.99235 12.5323C8.48323 12.5323 8.88116 12.1343 8.88116 11.6435Z",
    fill: "#E73535"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityCritical);
export default __webpack_public_path__ + "static/media/priority-critical.29697bf8518189e0c5dd74338cb4d019.svg";
export { ForwardRef as ReactComponent };